import { Checkbox, Radio } from "@chakra-ui/react";

import {useTheme} from "../../shared/hooks/ThemeProvider";

type RadioOrCheckboxProps = {
  children: JSX.Element;
  multipleChoice: boolean;
  value: string;
  isDisabled: boolean;
};

const RadioOrCheckbox = (props: RadioOrCheckboxProps) => {
  const theme = useTheme().theme;
  return (
    <>
      {props.multipleChoice ? (
        <Checkbox value={props.value} isDisabled={props.isDisabled}>
          {" "}
          {props.children}
        </Checkbox>
      ) : (
        <Radio value={props.value}
              borderColor={theme.OUTLINE}
               isDisabled={props.isDisabled}>
          {props.children}
        </Radio>
      )}
    </>
  );
};

export default RadioOrCheckbox;
